import { defineComponent } from 'vue';
import ProcessorComponent from '@/components/ProcessorComponent.vue';
export default defineComponent({
    name: 'ProcessorDuplicateDialog',
    props: {
        propSelected: Array,
        propId: String
    },
    components: { ProcessorComponent },
    data: function () {
        return {
            show: false,
            id: this.propId
        };
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        },
        showHideDialog() {
            this.show = !this.show;
        },
        createNew() {
            this.show = true;
        }
    }
});
